import React from "react";

export const ContentScreenLayout = ({ children }) => (
  <section className="content-scrren-layout">{children}</section>
);
